/* Pelier · añadir a la cesta desde bloques propios y abrir el carrito del tema (AbadMedia) */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  window.plAdd = async (items, code) => {
    const sections = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items, sections: [...sections].join(',') }) });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'error');
    if (code) {
      const u = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code, sections: [...sections].join(',') }) }).then((r) => r.json()).catch(() => null);
      if (u && u.sections) json.sections = u.sections;
    }
    const cart = await (await fetch(`${root}cart.js`)).json();
    cart.sections = json.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
    return json;
  };
  const sizeOf = () => {
    let vals = [];
    try { vals = JSON.parse(document.querySelector('variant-picker script[data-variant]').textContent).options || []; } catch (e) {}
    if (!vals.length) vals = [...document.querySelectorAll('variant-picker input:checked')].map(i => (document.querySelector(`label[for="${i.id}"]`) || {}).textContent || '').map(t => t.trim());
    return vals.find(v => /^(XXS|XS|S|M|L|XL|XXL|XS\/S|S\/M|M\/L|L\/M)$/i.test(v)) || vals[vals.length - 1];
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pl-look-add]');
    if (!btn) return;
    const box = btn.closest('[data-pl-look]');
    const msg = box.querySelector('[data-pl-look-msg]');
    const variants = JSON.parse(box.dataset.variants || '[]');
    const size = (sizeOf() || '').toLowerCase();
    const v = variants.find(x => x.available && x.options.some(o => o.toLowerCase() === size)) || variants.find(x => x.available && x.options.some(o => o.toLowerCase().startsWith(size)));
    const es = document.documentElement.lang.startsWith('es');
    if (!v) { msg.hidden = false; msg.textContent = es ? `No queda en talla ${size.toUpperCase()}. Elige otra en su ficha.` : `Not available in ${size.toUpperCase()}.`; return; }
    btn.setAttribute('aria-busy', 'true');
    try {
      await window.plAdd([{ id: v.id, quantity: 1 }]);
      msg.hidden = false; msg.textContent = (es ? 'Añadido en talla ' : 'Added in size ') + size.toUpperCase();
    } catch (err) {
      msg.hidden = false; msg.textContent = err.message;
    } finally { btn.removeAttribute('aria-busy'); }
  });
})();

/* Pelier · «¿Quieres añadir algo más?» (AbadMedia) */
(() => {
  const money = (c) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(c / 100);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const mainVariantId = () => {
    const i = document.querySelector('.shopify-section--main-product form[action$="/cart/add"] input[name="id"], form[action*="/cart/add"][id*="product-form"] input[name="id"]');
    return i && i.value ? Number(i.value) : null;
  };
  const mainSize = () => {
    try { const o = JSON.parse(document.querySelector('variant-picker script[data-variant]').textContent).options || []; return (o[o.length - 1] || '').toLowerCase(); } catch (e) { return ''; }
  };
  const init = (box) => {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    const data = JSON.parse(box.querySelector('[data-pl-up-data]').textContent);
    if (!data.tabs.length) return;
    const es = box.dataset.es === 'true';
    const code = box.dataset.code; const pct = Number(box.dataset.percent) || 0;
    const packOn = !!code && pct > 0 && data.cur.ok; let pack = packOn;
    const q = (s) => box.querySelector(s); const qa = (s) => box.querySelectorAll(s);
    const st = { t: 0, p: null, v: null };
    const anyOk = data.tabs.some((t) => t.items.some((p) => p.ok));
    const other = data.tabs.length === 1 && /otro conjunto|another set/i.test(data.tabs[0].label);
    if (other) q('[data-sub]').textContent = es ? (pack && anyOk ? `¿Te llevas otro color? Ahorra un ${pct} % con los dos` : '¿Te llevas otro color?') : 'Want another colour?';
    else q('[data-sub]').textContent = es ? (pack && anyOk ? `Completa el conjunto y ahorra un ${pct} %` : 'Completa el conjunto') : (pack && anyOk ? `Complete the set and save ${pct}%` : 'Complete the set');
    const tabs = q('[data-tabs]');
    if (data.tabs.length > 1) data.tabs.forEach((t, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'pl-up__tab'; b.textContent = t.label;
      b.addEventListener('click', () => selTab(i)); tabs.appendChild(b);
    });
    const msg = (t) => { const m = q('[data-msg]'); m.textContent = t; m.hidden = !t; };
    function selTab(i) {
      st.t = i; [...tabs.children].forEach((b, j) => b.setAttribute('aria-selected', String(i === j)));
      const items = data.tabs[i].items; const sw = q('[data-swatches]'); sw.innerHTML = '';
      items.forEach((p) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'pl-up__swatch'; b.title = p.color;
        b.innerHTML = p.thumb ? `<img src="${p.thumb}" alt="${p.color}">` : p.color; b.addEventListener('click', () => selP(p)); sw.appendChild(b);
      });
      sw.hidden = items.length < 2;
      selP(items.find((p) => p.color === data.cur.color) || items[0]);
    }
    function selP(p) {
      st.p = p; const items = data.tabs[st.t].items;
      [...q('[data-swatches]').children].forEach((b, j) => b.setAttribute('aria-pressed', String(items[j] === p)));
      q('[data-img]').src = p.img; q('[data-img]').alt = p.title; qa('[data-link]').forEach((a) => a.href = p.url);
      q('[data-name]').textContent = p.title; q('[data-color]').textContent = p.color; q('[data-color]').parentNode.hidden = !p.color;
      q('[data-price]').innerHTML = money(p.price) + (p.compare > p.price ? ` <s>${money(p.compare)}</s>` : '');
      const sizes = q('[data-sizes]'); sizes.innerHTML = ''; st.v = null;
      const multi = p.v.length > 1; q('[data-size-label]').hidden = !multi;
      if (!multi) st.v = p.v[0].id;
      const want = mainSize();
      p.v.forEach((v) => {
        if (!multi) return;
        const b = document.createElement('button'); b.type = 'button'; b.className = 'pl-up__size'; b.textContent = v.t; b.disabled = !v.a;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', () => { st.v = v.id; [...sizes.children].forEach((x) => x.setAttribute('aria-pressed', String(x === b))); msg(''); });
        sizes.appendChild(b);
        if (v.a && v.t.toLowerCase() === want) { st.v = v.id; b.setAttribute('aria-pressed', 'true'); }
      });
      const lbl = data.tabs[st.t].label.toLowerCase();
      pack = packOn && p.ok;
      if (pack) {
        q('[data-pack-text]').innerHTML = `<span class="pl-up__badge">−${pct} % ${es ? 'llevando los dos' : 'buying both'}</span><span class="pl-up__prices"><s>${money(data.cur.price + p.price)}</s> <strong>${money(Math.round((data.cur.price + p.price) * (100 - pct) / 100))}</strong></span>`;
        q('[data-pack]').textContent = es ? `Añadir los dos · −${pct} %` : `Add both · −${pct}%`;
      } else {
        q('[data-pack-text]').innerHTML = `<span class="pl-up__prices">${es ? 'Los dos' : 'Both'}: <strong>${money(data.cur.price + p.price)}</strong></span>`;
        q('[data-pack]').textContent = es ? 'Añadir los dos' : 'Add both';
      }
      q('[data-pack]').hidden = false;
      if (p.only) {
        const save = p.compare > p.price ? p.compare - p.price : 0;
        q('[data-pack-text]').innerHTML = save ? `<span class="pl-up__badge">${es ? 'Ahorras' : 'Save'} ${money(save)}</span><span class="pl-up__prices"><s>${money(p.compare)}</s> <strong>${money(p.price)}</strong></span>` : '';
        q('[data-pack]').hidden = true;
        q('[data-single]').textContent = es ? 'Añadir el set completo' : 'Add the full set';
        q('[data-single]').classList.add('pl-up__btn--pack'); q('[data-single]').classList.remove('pl-up__btn--single');
        return;
      }
      q('[data-single]').classList.add('pl-up__btn--single'); q('[data-single]').classList.remove('pl-up__btn--pack');
      q('[data-single]').textContent = es ? `Añadir solo ${lbl === 'set' ? 'el set' : lbl === 'chaqueta' ? 'la chaqueta' : lbl === 'top' ? 'el top' : lbl === 'short' ? 'el short' : 'el legging'}` : `Add only the ${lbl}`;
    }
    async function add(both, btn) {
      if (!st.v) { msg(es ? 'Elige la talla' : 'Choose a size'); return; }
      const items = [{ id: st.v, quantity: 1 }];
      if (both) {
        const cv = mainVariantId();
        if (!cv) { msg(es ? 'Elige primero tu talla arriba' : 'Pick your size above first'); return; }
        const cart = await fetch(`${root}cart.js`).then((r) => r.json());
        if (!cart.items.some((i) => i.variant_id === cv)) items.unshift({ id: cv, quantity: 1 });
      }
      const label = btn.textContent; btn.disabled = true; btn.textContent = es ? 'Añadiendo…' : 'Adding…'; msg('');
      try {
        await window.plAdd(items, both && pack ? code : null);
        btn.classList.add('is-done'); btn.textContent = es ? 'Añadido ✓' : 'Added ✓';
      } catch (e) { msg(e.message); }
      setTimeout(() => { btn.disabled = false; btn.classList.remove('is-done'); btn.textContent = label; }, 2500);
    }
    q('[data-pack]').addEventListener('click', (e) => add(true, e.currentTarget));
    q('[data-single]').addEventListener('click', (e) => add(false, e.currentTarget));
    selTab(0); box.hidden = false;
  };
  const scan = () => document.querySelectorAll('[data-pl-up]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', scan) : scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Pelier · tarjetas grandes de la cesta (AbadMedia) */
document.addEventListener('click', async (e) => {
  const nav = e.target.closest('[data-pl-cx-nav]');
  if (nav) { const t = nav.closest('.pl-cx').querySelector('.pl-cx__track'); t.scrollBy({ left: Number(nav.dataset.plCxNav) * t.clientWidth * 0.9, behavior: 'smooth' }); return; }
  const b = e.target.closest('[data-pl-cx-add]');
  if (!b || b.disabled) return;
  b.setAttribute('aria-busy', 'true');
  try { await window.plAdd([{ id: Number(b.dataset.plCxAdd), quantity: 1 }]); } catch (err) { alert(err.message); }
  b.removeAttribute('aria-busy');
});
